import { File } from "lucide-react";
import React, { useRef } from "react";
import Button from "../../lib/ui/components/button/Button";
import { SmallText } from "../../lib/ui/components/typography/Typography";


const FileChooser = ({ handleFileChange, fileName }) => {
  const inputRef = useRef(null);

  const handleClick = () => {
    inputRef.current?.click();
  };

  return (
    <div className="flex items-center h-12 rounded-lg overflow-hidden border border-gray-200 bg-white w-full max-w-xl">
      <Button
        variant="secondary"
        onClick={handleClick}
        data-cy="csv-choose-button"
        className="h-full"
        leftIcon={<File size="1em" />}
      >
        Choose File
      </Button>
      <div className="ml-6 flex-1">
        <SmallText>{fileName}</SmallText>
      </div>
      <input
        data-cy="csv-input"
        ref={inputRef}
        type="file"
        className="hidden"
        onChange={handleFileChange}
      />
    </div>
  );
};

export default FileChooser;
